import {
  addDoc,
  collection,
  getFirestore,
  serverTimestamp,
} from "firebase/firestore";
import { store } from "@/store";
import { InboxStore } from "@/store/constants";
import { ICustomFieldInput } from "@/types/inbox/fields";

export const createFields = async (
  name: string,
  fields: ICustomFieldInput[]
): Promise<string> => {
  const chatbotId = store.getters[InboxStore.Getters.GET_CHATBOT_ID];
  const createdDoc = await addDoc(
    collection(
      getFirestore(),
      "dialogs/" + chatbotId + "/settings/inbox/fields"
    ),
    {
      name,
      fields,
      created: serverTimestamp(),
      updated: serverTimestamp(),
    }
  );
  return createdDoc.id;
};
